






















import FeedbackComponent from '@/components/base/FeedbackComponent'
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {GridColumn} from "@payroll/grid-widget/src/models/GridColumn";
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Action} from "vuex-class";

@Component({})
export default class WithdrawalAndTransfer extends FeedbackComponent {

  @Prop(String) memberIdNum!: string;
  @Action('getWithdrawalAndTransfer', StoreNamespace.CUSTOMER_SERVICE) getWithdrawalAndTransfer: any;

  private columns: GridColumn[] = [];
  private noData: string = '';
  private styleGridTimeout: any = null;
  private showWithdrawalAndTransferRowsError: boolean = false;
  private withdrawalAndTransferRows: any[] = []


  created() {
    this.$on('successResults', (data: any, index: number) => {

      if (this.styleGridTimeout) {
        clearTimeout(this.styleGridTimeout)
      }

      this.styleGridTimeout = setTimeout(() => {
        $('td.valueDate').each(function() {
          let dateText = $(this).text();
          let dateParts = dateText.split('/');

          if (dateParts.length === 3) {
            let day = parseInt(dateParts[0], 10);
            let month = parseInt(dateParts[1], 10) - 1;
            let year = parseInt(dateParts[2], 10);

            let operationDate = new Date(year, month, day);
            let yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);

            if (operationDate > yesterday) {
              $(this).closest('tr').css({
                'font-weight': 'bold',
                'font-size': '18px',
                'background-color': 'lightblue',
              });
            }
          }
        });

      }, 0)
    })
  }

  beforeDestroy() {
    if (this.styleGridTimeout) {
      clearTimeout(this.styleGridTimeout)
    }
  }

  mounted() {
    this.initColumns();

    this.getWithdrawalAndTransfer({
      requestorCallback: this,
      pathVariable: this.memberIdNum,
    });
  }

  onSortClicked({sortDirection, sortColumn}: any): void {
    const parseNumber = (value: string) => {
      if (!value) {
        return 0;
      }
      return parseFloat(value.replace(/[^\d.-]/g, ""));
    };

    const parseDate = (value: string) => {
      if (!value) {
        return new Date(0);
      }
      const [day, month, year] = value.split('/').map(num => parseInt(num, 10));
      return Date.UTC(year, month - 1, day);
    };


    const getSortValue = (row: any, column: string) => {
      switch (column) {
        case 'operationSum':
          return parseNumber(row[column]);
        case 'createDate':
        case 'valueDate':
          return parseDate(row[column]);
        default:
          return row[column];
      }
    };

    const sortedRows = [...this.withdrawalAndTransferRows].sort((a, b) => {
      const valueA = getSortValue(a, sortColumn);
      const valueB = getSortValue(b, sortColumn);

      const comparisonResult = valueA - valueB;

      return sortDirection === 'ASC' ? comparisonResult : -comparisonResult;
    });


    const objectData = {
      hasMore: false,
      resultCount: sortedRows.length,
      results: sortedRows
    };

    this.$nextTick(() => {
      this.$emit('successResults', objectData);
    });
  }


  initColumns(): void {
    this.columns.push({property: 'memberFundCode', header: 'WithdrawalAndTransfer.memberFundCode'})
    this.columns.push({property: 'memberFundAccount', header: 'WithdrawalAndTransfer.memberFundAccount'})
    this.columns.push({property: 'operationTypeCode', header: 'WithdrawalAndTransfer.operationTypeCode'})
    this.columns.push({property: 'operationTypeDesc', header: 'WithdrawalAndTransfer.operationTypeDesc'})
    this.columns.push({property: 'operationSum', header: 'WithdrawalAndTransfer.operationSum'})
    this.columns.push({property: 'createDate', header: 'WithdrawalAndTransfer.createDate'})
    this.columns.push({property: 'valueDate', header: 'WithdrawalAndTransfer.valueDate'})
    this.columns.push({property: 'setDate', header: 'WithdrawalAndTransfer.setDate'})
    this.columns.push({property: 'accountNumToCredit', header: 'WithdrawalAndTransfer.accountNumToCredit'})
  }


  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'withdrawalAndTransfer':
        this.showWithdrawalAndTransferRowsError = false;
        this.getWithdrawalAndTransfer = data.veiwsArray;
        this.withdrawalAndTransferRows = data.veiwsArray;
        if (data.veiwsArray) {
          const objectData = {
            hasMore: false,
            resultCount: data.veiwsArray.length,
            results: data.veiwsArray
          }
          this.$emit('successResults', objectData)
        }
        else  {
          this.noData = data.responseDesc;
        }

        break;
    }

  }

  onError(messages: string[], code: number, requestName?: string): void {
    switch (requestName) {
      case 'withdrawalAndTransfer':
        this.showWithdrawalAndTransferRowsError = true;
        break
      default:
        this.handleOnError(messages, code, requestName)
    }
  }
}


